import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot } from "vue";
const _hoisted_1 = { class: "contents-title-text" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_SupplyInfoDialog = _resolveComponent("SupplyInfoDialog");
    const _component_v_card_title = _resolveComponent("v-card-title");
    const _component_v_card = _resolveComponent("v-card");
    return (_openBlock(), _createBlock(_component_v_card, {
        flat: "",
        outlined: "",
        class: "brg-table table-card-wrapper"
    }, {
        default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "d-flex justify-space-between" }, {
                default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$t(`${_ctx.lc}${_ctx.title}`)), 1 /* TEXT */),
                    (!_ctx.isTestMode)
                        ? (_openBlock(), _createBlock(_component_SupplyInfoDialog, {
                            key: 0,
                            title: _ctx.$t(`${_ctx.lc}${_ctx.title}`),
                            lc: _ctx.lc,
                            onOnClickButton: _ctx.handleClickSupplyInfoButton
                        }, null, 8 /* PROPS */, ["title", "lc", "onOnClickButton"]))
                        : _createCommentVNode("v-if", true)
                ]),
                _: 1 /* STABLE */
            }),
            _renderSlot(_ctx.$slots, "hubReportTable", {}, undefined, true)
        ]),
        _: 3 /* FORWARDED */
    }));
}
